import cookies from 'js-cookie';


const UC_TOKEN_GLOBAL = 'UC_TOKEN_GLOBAL';

// 判断平台是否登录
export const isUCLoggedIn = () => {
    return !!cookies.get(UC_TOKEN_GLOBAL);
};

// 获取平台环境变量
export const getUcEnv = () => {
    let env = 'prod';
    if (location.hostname.indexOf('test') > -1) {
        env = 'test';
    }
    return env;
};

// 获取平台用户信息Key
export const getUCInfoKey = () => {
    const ucAppid = cookies.get('G7E6_SYS_CODE') || '';
    const ucEnv = getUcEnv();
    let ucSysCode = '';

    switch (ucAppid) {
        case 'cyt_openapi':
            ucSysCode = 'cyt';
            break;
        case 'g7s_openapi':
            ucSysCode = 'g7s';
            break;
        case 'e6yun_openapi':
            ucSysCode = 'e6yun';
            break;
        default:
            ucSysCode = '';
    }
    return `UC_INFO_${ucSysCode}_${ucEnv}`.toUpperCase();
};


// 获取平台header
export const getUCHeaders = () => {
    const ucAppid = cookies.get('G7E6_SYS_CODE') || '';
    const ucInfoKey = getUCInfoKey();

    return {
        'G7e6-Uc-Token': cookies.get(UC_TOKEN_GLOBAL) || '',
        'G7e6-Sys-Code': ucAppid,
        'G7e6-Uc-Tinfo': cookies.get(ucInfoKey) || ''
    };
};


// 清除平台Cookie，除info
export const clearUcToken = () => {
    const ucEnv = getUcEnv();
    let options = { secure: true, sameSite: 'none' };
    if (ucEnv === 'test') {
        options = { domain: '.chinawayltd.com', secure: true, sameSite: 'none' };
    }
    cookies.remove(UC_TOKEN_GLOBAL, options);
    cookies.remove('G7E6_SYS_CODE', options);
    cookies.remove('UC_LANG', options);
};



// WEBPACK FOOTER //
// ./src/assets/js/uc.js